import {useMemo} from "react";

import {useTranslation} from "react-i18next";

export const usePhaseOptions = () => {
  const {t} = useTranslation();

  const phaseOptions = useMemo(
    () => [
      {id: 0, value: "primary", label: t("input.primary")},
      {id: 1, value: "secondary", label: t("input.repeated")},
    ],
    [t],
  );

  return phaseOptions;
};
